import React from "react";
import { FilterModalSelect } from "./FilterModalSelect";
import { useIssueTypes } from "src/utils/CommonDataFetchingUtils/useIssueTypes";

interface IssueTypeFilterProps {
  issueType: string;
  setSelectedIssueType: (value: string) => void;
}

export const IssueTypeFilter = ({
  issueType,
  setSelectedIssueType,
}: IssueTypeFilterProps) => {
  const { issueTypes } = useIssueTypes();

  return (
    <FilterModalSelect
      label="Issue Type"
      value={issueType}
      onChange={setSelectedIssueType}
      placeholderText="Select Issue Type"
      options={issueTypes}
    />
  );
};
